import { Plugin } from '@ckeditor/ckeditor5-core';

export class ListLevelLimit extends Plugin {
    private readonly maxLevel = 1; // 0-based. 1 means 2 levels.

    static get pluginName() {
        return 'ListLevelLimit'
    }

    init() {
        const editor = this.editor;

        editor.model.document.on( 'change', event => {
            const selectedElement = editor.model.document.selection.getFirstPosition()!.parent;
            const indentListCommand = editor.commands.get( 'indentList' );

            if( selectedElement.name === 'listItem' && selectedElement.getAttribute( 'listIndent' )! >= this.maxLevel ) {
                indentListCommand!.forceDisabled('ListLevelLimit');
            } else {
                indentListCommand!.clearForceDisabled('ListLevelLimit');
            }
        } );
    }
}